import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";

import { BiMouse } from "react-icons/bi";
import { FaRulerCombined } from "react-icons/fa";
import { MdOutlineAssignment } from "react-icons/md";

import { ClientSlider, HomeSlider } from "../Components/HomeSlider";
import AboutSection from "../Components/AboutSection";

function OurService() {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="container mb-20 mt-18  mx-auto md:px-6">
      <div className="md:mx-10 my-5">
        <h2 className="font-extrabold my-5	leading-snug	text-center py-5 text-4xl font-teko">
          OUR SERVICES
        </h2>
        <p className="text-center text-md">
          HMT Technical Services focuses on offering statutory inspections,
          safety audits, and risk assessment solutions to ensure compliance,
          protect lives, and prevent operational hazards in industrial facilities.
        </p>
      </div>
      <div className="flex flex-wrap w-[100%]">
        <div className="p-2 w-[100%] md:w-[30%]">
          <nav
            className="flex flex-col space-y-4"
            aria-label="Tabs"
            role="tablist"
            data-hs-tabs-vertical="true"
          >
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 1
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white ng-red"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap  active`}
              id="vertical-tab-with-border-item-1"
              data-hs-tab="#vertical-tab-with-border-1"
              aria-controls="vertical-tab-with-border-1"
              role="tab"
              onClick={() => handleTabClick(1)}
            >
              01. Custom Software Development
            </button>
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 2
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap 
               active`}
              id="vertical-tab-with-border-item-2"
              data-hs-tab="#vertical-tab-with-border-2"
              aria-controls="vertical-tab-with-border-2"
              role="tab"
              onClick={() => handleTabClick(2)}
            >
              02. Software Consulting
            </button>
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 3
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap active`}
              id="vertical-tab-with-border-item-3"
              data-hs-tab="#vertical-tab-with-border-3"
              aria-controls="vertical-tab-with-border-3"
              role="tab"
              onClick={() => handleTabClick(3)}
            >
              03. E-Commerce Solutions
            </button>
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 4
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap active`}
              id="vertical-tab-with-border-item-4"
              data-hs-tab="#vertical-tab-with-border-4"
              aria-controls="vertical-tab-with-border-4"
              role="tab"
              onClick={() => handleTabClick(4)}
            >
              04. Apps Development
            </button>
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 5
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap active`}
              id="vertical-tab-with-border-item-5"
              data-hs-tab="#vertical-tab-with-border-5"
              aria-controls="vertical-tab-with-border-5"
              role="tab"
              onClick={() => handleTabClick(5)}
            >
              05. Cyber Security
            </button>
          </nav>
        </div>

        <div className="p-2 w-[100%] md:w-[70%]">
          <div
            id="vertical-tab-with-border-2"
            className={activeTab === 1 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-2"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/softwaredevelopment.jpg"
                  alt="softwaredevelopment.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">
                  Custom Software Development
                </h3>
                <p className="text-justify">
                  Our specialised Customized Software Development is the process
                  of designing, building, deploying, and maintaining software
                  for all types of SME’s and MSME’s that is tailored to their
                  needs and aims to improve every industry to a new level.
                </p>
              </div>
            </div>
          </div>
          <div
            id="vertical-tab-with-border-2"
            className={activeTab === 2 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-2"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/softwareconsulting.jpg"
                  alt="softwareconsulting.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">
                  Software Consultancy
                </h3>
                <p className="text-justify">
                  HMT Technical Services diagnose, analyze,
                  identify, plan, and offer solutions that are compatible with
                  every organization's needs. Expertizing our knowledge and
                  experience at all instances accelerates.
                </p>
              </div>
            </div>
          </div>
          <div
            id="vertical-tab-with-border-3"
            className={activeTab === 3 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-3"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/ecommerce.jpg"
                  alt="ecommerce.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">
                  E-Commerce Solutions
                </h3>
                <p className="text-justify">
                  Our E-Commerce Software facilitates quicker and trusted growth
                  of income and profit for both, beginner's playground, and an
                  expert home field by meeting the demands of any small- to
                  medium-sized firm.
                </p>
              </div>
            </div>
          </div>
          <div
            id="vertical-tab-with-border-4"
            className={activeTab === 4 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-4"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/apps.jpg"
                  alt="apps.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">Apps Development</h3>
                <p className="text-justify">
                  Our Application Development assists you in creating beneficial
                  and efficient experiences on every device and help you get the
                  most out of mobile Technology for your business with our
                  Application Development Services, which draw on our team's
                  strong expertise in developing Customized Applications.
                </p>
              </div>
            </div>
          </div>
          <div
            id="vertical-tab-with-border-5"
            className={activeTab === 5 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-5"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/cyber.jpg"
                  alt="cyber.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">Cyber Security</h3>
                <p className="text-justify">
                  To guarantee that your industrial systems and data are safe, HMT
                  Technical Services employs specialized assessments to execute controlled
                  evaluations and penetration testing of your firewalls and network
                  entry points.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Home = () => {
  return (
    <div>
      <HomeSlider />
      <AboutSection/>

      {/* <section className="pt-20 lg:pt-[120px] pb-12 lg:pb-[90px] overflow-hidden w-[95%] mx-2 px-10">
        <div className="flex flex-wrap items-center justify-between -mx-4">
          <div className="w-full px-4 lg:w-6/12">
            <div className="flex items-center -mx-3 sm:-mx-4">
              <div className="w-full px-3 sm:px-4 xl:w-1/2">
                <div className="py-3 sm:py-4">
                  <img
                    src="./img/Gallery3.jpg"
                    alt=""
                    className="w-full rounded-2xl"
                  />
                </div>
                <div className="py-3 sm:py-4">
                  <img
                    src="./img/Gallery1.jpg"
                    alt=""
                    className="w-full rounded-2xl"
                  />
                </div>
              </div>
              <div className="w-full px-3 sm:px-4 xl:w-1/2">
                <div className="relative z-10 my-4">
                  <img
                    src="./img/Gallery2.jpg"
                    alt=""
                    className="w-full rounded-2xl"
                  />
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-4 py-3 bg-gray-500/50 w-full flex items-center justify-center flex-col text-center h-full ">
                    <div></div>
                    <h1 className="text-white flex items-center justify-center font-bold h-[100px] w-[100px] mx-auto text-4xl border-2 border-black text-center">
                      18
                    </h1>
                    <p className="text-white font-semibold text-1xl my-2">
                      Years Experience
                    </p>
                  </div>
                  <span className="absolute -right-7 -bottom-7 z-[-1]">
                    <svg
                      width={134}
                      height={106}
                      viewBox="0 0 134 106"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="1.66667"
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 1.66667 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="16.3333"
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 16.3333 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={31}
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 31 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="45.6667"
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 45.6667 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="60.3334"
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 60.3334 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="88.6667"
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 88.6667 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="117.667"
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 117.667 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="74.6667"
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 74.6667 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={103}
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 103 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={132}
                        cy={104}
                        r="1.66667"
                        transform="rotate(-90 132 104)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="1.66667"
                        cy="89.3333"
                        r="1.66667"
                        transform="rotate(-90 1.66667 89.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="16.3333"
                        cy="89.3333"
                        r="1.66667"
                        transform="rotate(-90 16.3333 89.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={31}
                        cy="89.3333"
                        r="1.66667"
                        transform="rotate(-90 31 89.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="45.6667"
                        cy="89.3333"
                        r="1.66667"
                        transform="rotate(-90 45.6667 89.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="60.3333"
                        cy="89.3338"
                        r="1.66667"
                        transform="rotate(-90 60.3333 89.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="88.6667"
                        cy="89.3338"
                        r="1.66667"
                        transform="rotate(-90 88.6667 89.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="117.667"
                        cy="89.3338"
                        r="1.66667"
                        transform="rotate(-90 117.667 89.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="74.6667"
                        cy="89.3338"
                        r="1.66667"
                        transform="rotate(-90 74.6667 89.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={103}
                        cy="89.3338"
                        r="1.66667"
                        transform="rotate(-90 103 89.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={132}
                        cy="89.3338"
                        r="1.66667"
                        transform="rotate(-90 132 89.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="1.66667"
                        cy="74.6673"
                        r="1.66667"
                        transform="rotate(-90 1.66667 74.6673)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="1.66667"
                        cy="31.0003"
                        r="1.66667"
                        transform="rotate(-90 1.66667 31.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="16.3333"
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 16.3333 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="16.3333"
                        cy="31.0003"
                        r="1.66667"
                        transform="rotate(-90 16.3333 31.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={31}
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 31 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={31}
                        cy="31.0003"
                        r="1.66667"
                        transform="rotate(-90 31 31.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="45.6667"
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 45.6667 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="45.6667"
                        cy="31.0003"
                        r="1.66667"
                        transform="rotate(-90 45.6667 31.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="60.3333"
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 60.3333 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="60.3333"
                        cy="30.9998"
                        r="1.66667"
                        transform="rotate(-90 60.3333 30.9998)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="88.6667"
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 88.6667 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="88.6667"
                        cy="30.9998"
                        r="1.66667"
                        transform="rotate(-90 88.6667 30.9998)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="117.667"
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 117.667 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="117.667"
                        cy="30.9998"
                        r="1.66667"
                        transform="rotate(-90 117.667 30.9998)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="74.6667"
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 74.6667 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="74.6667"
                        cy="30.9998"
                        r="1.66667"
                        transform="rotate(-90 74.6667 30.9998)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={103}
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 103 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={103}
                        cy="30.9998"
                        r="1.66667"
                        transform="rotate(-90 103 30.9998)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={132}
                        cy="74.6668"
                        r="1.66667"
                        transform="rotate(-90 132 74.6668)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={132}
                        cy="30.9998"
                        r="1.66667"
                        transform="rotate(-90 132 30.9998)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="1.66667"
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 1.66667 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="1.66667"
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 1.66667 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="16.3333"
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 16.3333 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="16.3333"
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 16.3333 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={31}
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 31 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={31}
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 31 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="45.6667"
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 45.6667 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="45.6667"
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 45.6667 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="60.3333"
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 60.3333 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="60.3333"
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 60.3333 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="88.6667"
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 88.6667 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="88.6667"
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 88.6667 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="117.667"
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 117.667 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="117.667"
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 117.667 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="74.6667"
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 74.6667 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="74.6667"
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 74.6667 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={103}
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 103 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={103}
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 103 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={132}
                        cy="60.0003"
                        r="1.66667"
                        transform="rotate(-90 132 60.0003)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={132}
                        cy="16.3333"
                        r="1.66667"
                        transform="rotate(-90 132 16.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="1.66667"
                        cy="45.3333"
                        r="1.66667"
                        transform="rotate(-90 1.66667 45.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="1.66667"
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 1.66667 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="16.3333"
                        cy="45.3333"
                        r="1.66667"
                        transform="rotate(-90 16.3333 45.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="16.3333"
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 16.3333 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={31}
                        cy="45.3333"
                        r="1.66667"
                        transform="rotate(-90 31 45.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={31}
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 31 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="45.6667"
                        cy="45.3333"
                        r="1.66667"
                        transform="rotate(-90 45.6667 45.3333)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="45.6667"
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 45.6667 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="60.3333"
                        cy="45.3338"
                        r="1.66667"
                        transform="rotate(-90 60.3333 45.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="60.3333"
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 60.3333 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="88.6667"
                        cy="45.3338"
                        r="1.66667"
                        transform="rotate(-90 88.6667 45.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="88.6667"
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 88.6667 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="117.667"
                        cy="45.3338"
                        r="1.66667"
                        transform="rotate(-90 117.667 45.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="117.667"
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 117.667 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="74.6667"
                        cy="45.3338"
                        r="1.66667"
                        transform="rotate(-90 74.6667 45.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx="74.6667"
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 74.6667 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={103}
                        cy="45.3338"
                        r="1.66667"
                        transform="rotate(-90 103 45.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={103}
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 103 1.66683)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={132}
                        cy="45.3338"
                        r="1.66667"
                        transform="rotate(-90 132 45.3338)"
                        fill="#3056D3"
                      />
                      <circle
                        cx={132}
                        cy="1.66683"
                        r="1.66667"
                        transform="rotate(-90 132 1.66683)"
                        fill="#3056D3"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full px-4 lg:w-1/2 xl:w-5/12">
            <div className="mt-10 lg:mt-0">
              <span className="block mb-2 text-lg font-semibold text-blue-400">
                ABOUT US
              </span>
              <p className="mb-8 text-base text-slate-600	 text-justify">
                Established in the year of 2019, we Recon Calibration & Test Labs
                LLP ( Formerlyknow as Reckon Calibration Services )is an
                industry leader in providing fast, quality, accredited
                calibration services across India.
                <br />
                <br /> As an ISO/IEC 17025:2017 accredited laboratory, we offer
                a full range of calibration services to our customers who are
                focused on achieving the highest quality standards. At Recon
                Calibration & Test Labs LLP, we recognize the critical nature of
                ensuring trusted measurements, which is why we provide a
                one-stop calibration services that meets our customer’s unique
                requirements.
                <br />
                <br />
                We provide calibration services for a broad array of disciplines
                and instruments including electrical, pressure, dimensional, and
                temperature calibration, allowing you to fulfill your needs from
                a single, reliable vendor. We make sure to go above and beyond
                to ensure a world-class experience by focusing on accuracy and
                risk mitigation, so you can focus on your core business.
              </p>
              <div className=" w-full my-10">
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-2">
                  <div className="flex flex-col gap-2">
                    <h3 className="flex gap-5 items-center">
                      <FaCheck className="text-orange-400 text-md font-bold" />
                      <span className="font-semibold text-md">
                        Quality Services
                      </span>
                    </h3>
                    <h3 className="flex gap-5 items-center">
                      <FaCheck className="text-orange-400 text-md font-bold" />
                      <span className="font-semibold text-md">
                        Competitive Cost
                      </span>
                    </h3>
                    <h3 className="flex gap-5 items-center">
                      <FaCheck className="text-orange-400 text-md font-bold" />
                      <span className="font-semibold text-md">
                        Economic Efficiencies
                      </span>
                    </h3>
                  </div>
                  <div className="flex flex-col gap-2">
                    <h3 className="flex gap-5 items-center">
                      <FaCheck className="text-orange-400 text-md font-bold" />
                      <span className="font-semibold text-md">
                        Innovative Digitalization
                      </span>
                    </h3>
                    <h3 className="flex gap-5 items-center">
                      <FaCheck className="text-orange-400 text-md font-bold" />
                      <span className="font-semibold text-md">
                        Updated Technology
                      </span>
                    </h3>
                    <h3 className="flex gap-5 items-center">
                      <FaCheck className="text-orange-400 text-md font-bold" />
                      <span className="font-semibold text-md">
                        24/7 Technical Support
                      </span>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="grid md:grid-cols-3 lg:gap-x-12 my-5">
                <div className="mb-12 md:mb-0">
                  <h2 className="mb-4 text-3xl font-bold text-primary">
                    200<sup>+</sup>
                  </h2>
                  <h5 className="mb-0 text-md font-medium text-black">
                    Happy Clients
                  </h5>
                </div>
                <div className="mb-12 md:mb-0">
                  <h2 className="mb-4 text-3xl font-bold text-primary">80%</h2>
                  <h5 className="mb-0 text-md font-medium text-black">
                    Growth
                  </h5>
                </div>
              </div>
              <Link to="/about">
                <button className="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 ">
                  <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white  rounded-md group-hover:bg-opacity-0 text-center inline-flex items-center">
                    Read More
                    <svg
                      className="w-3.5 h-3.5 ml-2"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 10"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M1 5h12m0 0L9 1m4 4L9 9"
                      />
                    </svg>
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section> */}

      <section
        className="bg-cover max-w-full h-auto my-1"
        // style={{ backgroundImage: "url('./img/homeourprod.jpg')" }}
      >
        <div className="text-center w-[60%] m-auto py-3  font-teko">
          {/* <h5 className="text-2xl font-[500]">Our Products</h5> */}
          <h6 className="text-4xl font-[800]">Our Authorizations</h6>
          <p className="text-gray-700 max-w-3xl mx-auto my-3">
            Approved Competent Person under the Factories Act 1948 (Section 28, 29, 31, 21(2)) for industrial testing, safety audits, and certifications.
          </p>
        </div>
      </section>

      {/* {OurService()} */}

      {WhyChooseUsSection()}

      {/* Services Preview Section */}
      <section className="py-16 px-4 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-[800] mb-4 text-slate-800">Our Services</h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-lg">
            Statutory inspections, testing, certifications, and industrial safety audits
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <Link to="/services" className="group">
            <div className="p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-sm border border-blue-100 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl mb-4">🏗️</div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Lifts And Hoists</h3>
              <p className="text-gray-600 text-sm">
                Testing and certification under Section 28 as per Factories Act 1948
              </p>
            </div>
          </Link>
          <Link to="/services" className="group">
            <div className="p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-sm border border-blue-100 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl mb-4">⛓️</div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Lifting Machinery</h3>
              <p className="text-gray-600 text-sm">
                Testing of cranes, tackles, chains, and ropes under Section 29
              </p>
            </div>
          </Link>
          <Link to="/services" className="group">
            <div className="p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-sm border border-blue-100 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl mb-4">🧪</div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Pressure Vessels</h3>
              <p className="text-gray-600 text-sm">
                Testing and certification of pressure plants and vessels under Section 31
              </p>
            </div>
          </Link>
          <Link to="/services" className="group">
            <div className="p-6 bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-sm border border-blue-100 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl mb-4">📋</div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Safety Audits</h3>
              <p className="text-gray-600 text-sm">
                Thorough process safety audits and compliance certifications
              </p>
            </div>
          </Link>
        </div>
      </section>

      <ClientSlider />
    </div>
  );
};

export default Home;

const WhyChooseUsSection = () => {
  return (
    <section className="py-16 px-4 max-w-7xl mx-auto bg-gradient-to-br from-gray-50 to-white rounded-3xl shadow-sm my-10">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-[800] mb-4 text-slate-800">
          Why Choose HMT Technical Services
        </h2>
        <p className="text-gray-600 max-w-3xl mx-auto text-lg">
          Your trusted partner for fire, safety engineering, third party inspection, and safety audits
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-8">
        {/* Get Started Column */}
        <div className="text-center p-8 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-blue-100 rounded-full">
              <BiMouse className="w-12 h-12 text-blue-600" />
            </div>
          </div>
          <h3 className="text-xl font-bold mb-4 text-slate-800">
            Statutory TPI Services
          </h3>
          <p className="text-gray-600">
            Approved competent testing and certification under Sections 21(2), 28, 29, and 31 of the Factories Act 1948
          </p>
        </div>

        {/* Prepare Column */}
        <div className="text-center p-8 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-blue-100 rounded-full">
              <FaRulerCombined className="w-12 h-12 text-blue-600" />
            </div>
          </div>
          <h3 className="text-xl font-bold mb-4 text-slate-800">
            Expert Safety Engineers
          </h3>
          <p className="text-gray-600">
            A highly qualified team of specialists, risk control engineers, quality assessors, and chartered engineers
          </p>
        </div>

        {/* Results Column */}
        <div className="text-center p-8 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-blue-100 rounded-full">
              <MdOutlineAssignment className="w-12 h-12 text-blue-600" />
            </div>
          </div>
          <h3 className="text-xl font-bold mb-4 text-slate-800">
            Government Liaison & NOCs
          </h3>
          <p className="text-gray-600">
            Liaison with various departments for obtaining licenses from the Factories Department and approvals from PESO
          </p>
        </div>
      </div>
    </section>
  );
};
